<template lang="pug">
div
  .checkbox-element.cntr(v-for="checkbox in checkboxList")
    input.inputCheckbox(
      :name="`${field}[]`",
      type="checkbox",
      :id="checkbox.id",
      :value="checkbox.id",
      v-model="selectedItems",
      @change="handleCheckboxClick"
    )
    label(:class="inputStyle(checkbox.id)", :for="checkbox.id")
    span {{ t(`components.forms.ambitos.${checkbox.id}`) }}
</template>

<script>
import mixins from "common/mixins.js";

export default {
  name: "checkbox-selector-vue",
  props: {
    field: { type: String, default: () => "" },
    checkboxList: { type: Array, default: () => [] },
    defaultStyle: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedItems: [],
      loading: false
    }
  },
  mixins: [mixins.translate],
  methods: {
    handleCheckboxClick() {
      this.$emit("checkbox:clicked", this.selectedItems)
    },
    inputStyle(id) {
      let baseStyle = "cbx ";
      baseStyle += this.defaultStyle ? "default" : id
      return baseStyle;
    }
  },
};
</script>
